import React from "react";
import { Box, List, ListItem, ListItemAvatar, Avatar, Typography } from "@mui/material";
import { format } from "date-fns";
import Attachment from "./Attachment";
import getAvatarInitials from "utils/getAvatarInitials";
import { renderMessageWithLinks } from "utils/renderMessageWithLinks";

const ChimeMessageList = ({ messages = [], messagesEndRef }) => {
  return (
    <List disablePadding sx={{ marginTop: "auto" }}>
      {messages.map((msg) => {
        const metadata = msg.Metadata ? JSON.parse(msg.Metadata) : msg.metadata || {};

        return (
          <ListItem
            key={msg.id || msg.MessageId}
            disableGutters
            sx={{ alignItems: "flex-start", gap: 4 }}
          >
            <ListItemAvatar sx={{ minWidth: 0 }}>
              <Avatar src={metadata.avatarUrl} size="32px">
                {getAvatarInitials(metadata.fullName)}
              </Avatar>
            </ListItemAvatar>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 4,
                }}
              >
                <Typography variant="subtitle1">{metadata.fullName || "Unknown Sender"}</Typography>
                <Typography variant="caption">
                  {format(new Date(metadata.sentAt || msg.CreatedTimestamp), "p")}
                </Typography>
              </Box>
              {metadata?.attachmentUrl ? (
                <Attachment msg={msg} />
              ) : (
                <Typography variant="body2" color="text.secondary">
                  {renderMessageWithLinks(msg.content || msg.Content)}
                </Typography>
              )}
            </Box>
          </ListItem>
        );
      })}
      <div ref={messagesEndRef} />
    </List>
  );
};

export default ChimeMessageList;
